
export default function hScrollToRef(ref) {
  ref.offsetParent.scrollLeft = 
    ref.offsetLeft + (ref.clientWidth / 2)
                   - (document.body.clientWidth / 2);
}